/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import ScrollMagic from 'ScrollMagic';
import animationGSAP from 'animation.gsap';
import addIndicators from 'debug.addIndicators';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';

( function( app ) {
  const COMPONENT = {
    init: function() {
      // $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
      //   $( '.primary-nav' ).slideToggle();
      // } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '[rel="magnific-inline"]' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        modal: true,
      } );

      // $( '.magnific-image-zoom' ).magnificPopup( {
      //   delegate: 'a',
      //   type: 'image',
      //   closeOnContentClick: false,
      //   closeBtnInside: true,
      //   mainClass: 'mfp-with-zoom mfp-img-mobile',
      //   image: {
      //     verticalFit: true,
      //     horizontalFit: true,
      //     titleSrc: function( item ) {
      //       return item.el.attr( 'title' ) + ' &middot; <a class="image-source-link" href="'+item.el.attr( 'data-source' )+'" target="_blank">Full Image <span class="text-xs">(Opens in new tab)</span></a>';
      //     },
      //   },
      //   gallery: {
      //     enabled: false,
      //   },
      //   zoom: {
      //     enabled: true,
      //     duration: 300, // don't foget to change the duration also in CSS
      //     opener: function( element ) {
      //       return element.find( 'img' );
      //     },
      //   },

      // } );

      $( document ).on( 'click', '.popup-modal-dismiss', function() {
        const magnificPopup = $.magnificPopup.instance;
        // save instance in magnificPopup variable
        magnificPopup.close();
        // Close popup that is currently opened
      } );

      $( '.portfolio-page .project-types a' ).click( function() {
        sessionStorage.setItem( 'hlProjectType', $( this ).attr( 'data-type' ) );
        sessionStorage.setItem( 'hlProjectTypeURL', $( this ).attr( 'href' ) );
      } );

      if ( $( 'body' ).hasClass( 'single-project' ) ) {
        if ( sessionStorage.getItem( 'hlProjectType' ) ) {
          $( '.title-banner span.type' ).text( sessionStorage.getItem( 'hlProjectType' ) );
        }

        if ( sessionStorage.getItem( 'hlProjectTypeURL' ) ) {
          $( '.title-banner .back-to-projects-link' ).attr( 'href', sessionStorage.getItem( 'hlProjectTypeURL' ) );
        }
      }

      if ( !$( 'body' ).hasClass( 'single-project' ) && !$( 'body' ).hasClass( 'tax-type' ) ) {
        sessionStorage.removeItem( 'hlProjectType' );
        sessionStorage.removeItem( 'hlProjectTypeURL' );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
